
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_29107_393)","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M49.25 35.625V59.75a3 3 0 01-3 3h-42a3 3 0 01-3-3V4.25a3 3 0 013-3h42a3 3 0 013 3v21.53","stroke":"#fff"}}),_c('path',{attrs:{"d":"M18.51 10.25h13.48a2.656 2.656 0 002.656-2.656V1.25H15.854v6.344a2.656 2.656 0 002.656 2.656zM20.25 57.75h-14V6.25h9.208M44.25 38.875V57.75h-14M35.042 6.25h9.208v24.347M57.123 27.258l-9.987 9.987-8.428 3.752 3.752-8.427 14.646-14.646a3.306 3.306 0 014.676 4.675l-4.659 4.659zM46.862 36.971l-4.29-4.29M60.175 24.206l-4.676-4.675","stroke":"#fff"}}),_c('path',{attrs:{"d":"M20.25 24.25h-8v-8h8v8zM20.25 38h-8v-8h8v8zM20.25 51.75h-8v-8h8v8z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M27.3 20.29l2.781 2.782 5.643-5.644M27.3 34.04l2.781 2.782 5.643-5.644M28.69 50.572l5.644-5.644M28.69 44.928l5.644 5.644","stroke":"#56BFC7"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_29107_393"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    